/* A changing product stage, with optional pointer motion and no animation loop. */
if (!customElements.get('dut-electric-hero')) {
  customElements.define('dut-electric-hero', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.tabs = [...this.querySelectorAll('[data-hero-tab]')];
      this.scenes = [...this.querySelectorAll('[data-hero-scene]')];
      this.features = [...this.querySelectorAll('[data-hero-feature]')];
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      const choose = (index, focus = false) => {
        this.dataset.scene = String(index);
        this.tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
          this.scenes[i].hidden = i !== index;
          this.features[i].hidden = i !== index;
        });
        if (focus) this.tabs[index].focus({ preventScroll: true });
      };
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => choose(index), { signal });
        tab.addEventListener('keydown', (event) => {
          const keys = { ArrowRight: (index + 1) % this.tabs.length, ArrowLeft: (index + this.tabs.length - 1) % this.tabs.length, Home: 0, End: this.tabs.length - 1 };
          if (keys[event.key] === undefined) return;
          event.preventDefault();
          choose(keys[event.key], true);
        }, { signal });
      });
      const stage = this.querySelector('.dth-hero__stage');
      const reset = () => { stage.style.setProperty('--tilt-x', '0deg'); stage.style.setProperty('--tilt-y', '0deg'); };
      stage.addEventListener('pointermove', (event) => {
        if (this.motion.matches || event.pointerType !== 'mouse') return;
        const box = stage.getBoundingClientRect();
        stage.style.setProperty('--tilt-x', `${((event.clientY - box.top) / box.height - .5) * -6}deg`);
        stage.style.setProperty('--tilt-y', `${((event.clientX - box.left) / box.width - .5) * 7}deg`);
      }, { signal });
      stage.addEventListener('pointerleave', reset, { signal });
      this.motion.addEventListener('change', reset, { signal });
      this.dataset.ready = '';
    }
    disconnectedCallback() { this.controller?.abort(); cancelAnimationFrame(this.scrollFrame); }
  });
}
